/**
 * @format
 *
 */

import { useContext, useEffect, useState } from 'react';

import moment from 'jalali-moment';
import { useNavigate, useParams } from 'react-router';

import { EventContext } from '../../Contexts/EventContext';
import Loading from '../../Shared/Components/Loading';
import { error, success } from '../../Shared/Components/Toast';
import useApi from '../../Shared/hooks/api/Index';
import { number_format, submitGatewayForm } from '../../Shared/utils/helper';
import Master from '../Layouts/Master';

const ShowFactor = () => {
  const eventContext = useContext(EventContext);
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [walletLoading, setWalletLoading] = useState(false);
  const [paymentLoading, setPaymentLoading] = useState(false);

  useEffect(() => {
    getFactor();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);
  const getFactor = async () => {
    setLoading(true);
    await useApi.get(
      `/panel/factor/${id}`,
      {},
      (res) => {
        eventContext.factor = res.data.data;
        setLoading(false);
      },
      (err) => {
        setLoading(false);
        error('هنگام دریافت اطلاعات خطایی رخ داده است');
      },
    );
  };
  // const removeFactor = async (FactorId) => {
  // 	setRemoveLoading(true);

  // 	await useApi.delete(
  // 		`/panel/Factor/${FactorId}`,
  // 		{},
  // 		(res) => {
  // 			success('در انتظار پرداخت مورد نظر با موفقیت حذف شد');
  // 			setRemoveLoading(false);
  // 			setModalIsOpen(false);
  // 			getFactor();
  // 		},
  // 		(err) => {
  // 			setRemoveLoading(false);
  // 			setLoading(false);
  // 			error('حذف به علت خطا انجام نشد');
  // 		},
  // 	);
  // };

  const handlePay = async (wallet = false) => {
    const request = {
      factor_id: id,
      match_id: eventContext.factor?.match?.id,
    };
    if (wallet) {
      setWalletLoading(true);
      request['wallet'] = 1;
    } else {
      setPaymentLoading(true);
    }
    await useApi.post(
      `/payment`,
      request,
      (res) => {
        const { data } = res;
        if (data?.status === 422) {
          error(data?.message);
          setPaymentLoading(false);
          setWalletLoading(false);
          return;
        } else if (data?.status === 200) {
          if (!submitGatewayForm(data?.data)) {
            error('آدرس درگاه پرداخت دریافت نشد');
            setPaymentLoading(false);
            setWalletLoading(false);
            return;
          }
          success('در حال هدایت به صفحه پرداخت لطفا منتظر بمانید');
          setPaymentLoading(false);
          setWalletLoading(false);
          return;
        } else if (data?.status === 201) {
          navigate(
            `/panel/matches/financial-management/success?tracking_id=${data?.data?.tracking_id}`,
          );
          success('پرداخت با موفقیت انجام شد');
          setPaymentLoading(false);
          setWalletLoading(false);
          return;
        }
        setPaymentLoading(false);
        setWalletLoading(false);
      },
      (err) => {
        error('خطا در پرداخت');
        setPaymentLoading(false);
        setWalletLoading(false);
      },
    );
  };

  return loading ? (
    <Loading />
  ) : (
    <Master>
      <div className='d-flex flex-row justify-content-between border-bottom pb-2 my-3'>
        <div className='d-flex flex-row mt-2'>
          <i className='fad fa-list f-20 text-secondary mx-2'></i>
          <h1 className='text-secondary f-13 font-weight-bold mt-1 mb-0 p-0'>
            {eventContext.factor?.match?.title} -{' '}
            {eventContext.factor?.register?.match_age?.title} -{' '}
            {eventContext.factor?.register?.match_allowed_province_id?.name} -{' '}
            {eventContext.factor?.register?.match_kind?.name}
          </h1>
        </div>
      </div>
      <div className='row w-100 border rounded p-3'>
        <div className='col-12'>
          <div className='d-flex flex-row my-2 border-bottom pb-2 w-100'>
            <span className='f-14 font-weight-bold w-25'>
              مبلغ قابل پرداخت :{' '}
            </span>
            <span className='f-14 mx-3'>
              {number_format(eventContext.factor?.price)} ریال
            </span>
          </div>
          <div className='d-flex flex-row my-2 border-bottom pb-2 w-100'>
            <span className='f-14 font-weight-bold w-25'>تاریخ صدور‌ : </span>
            <span className='f-14 mx-3'>
              {moment(
                eventContext.factor?.created_at ?? '1990-01-01',
                'YYYY-MM-DD',
              )
                .locale('fa')
                .format('YYYY/MM/DD')}
            </span>
          </div>
          <div className='d-flex flex-row my-2 border-bottom pb-2 w-100'>
            <span className='f-14 font-weight-bold w-25'>مهلت پرداخت : </span>
            <span className='f-14 mx-3'>
              {moment(
                eventContext.factor?.match?.register_end ?? '1990-01-01',
                'YYYY-MM-DD',
              )
                .locale('fa')
                .format('YYYY/MM/DD')}
            </span>
          </div>
          <div className='d-flex flex-row my-2 border-bottom pb-2 w-100'>
            <span className='f-14 font-weight-bold w-25'>نوع مسابقه : </span>
            <span className='f-14 mx-3'>
              {eventContext.factor?.register?.match_kind?.name}
            </span>
          </div>
          <div className='d-flex flex-row my-2 border-bottom pb-2 w-100'>
            <span className='f-14 font-weight-bold w-25'> رده سنی : </span>
            <span className='f-14 mx-3'>
              {eventContext.factor?.register?.match_age?.title}
            </span>
          </div>
          <div className='d-flex flex-row my-2 border-bottom pb-2 w-100'>
            <span className='f-14 font-weight-bold w-25'> شروع برگزاری : </span>
            <span className='f-14 mx-3'>
              {moment(
                eventContext.factor?.match?.start ?? '1990-01-01',
                'YYYY-MM-DD',
              )
                .locale('fa')
                .format('YYYY/MM/DD')}
            </span>
          </div>
          <div className='d-flex flex-row my-2 border-bottom pb-2 w-100'>
            <span className='f-14 font-weight-bold w-25'> شروع برگزاری : </span>
            <span className='f-14 mx-3'>
              {moment(
                eventContext.factor?.match?.end ?? '1990-01-01',
                'YYYY-MM-DD',
              )
                .locale('fa')
                .format('YYYY/MM/DD')}
            </span>
          </div>
          <div className='d-flex flex-row my-2 border-bottom pb-2 w-100'>
            <span className='f-14 font-weight-bold w-25'>
              {' '}
              استان برگزاری :{' '}
            </span>
            <span className='f-14 mx-3'>
              {eventContext.factor?.match?.province?.name}
            </span>
          </div>
          <div className='d-flex flex-row my-2 border-bottom pb-2 w-100'>
            <span className='f-14 font-weight-bold w-25'> شهر برگزاری : </span>
            <span className='f-14 mx-3'>
              {eventContext.factor?.match?.city?.name}
            </span>
          </div>
          <div className='d-flex flex-row my-2 border-bottom pb-2 w-100'>
            <span className='f-14 font-weight-bold w-25'> آدرس برگزاری : </span>
            <span className='f-14 mx-3'>
              {eventContext.factor?.match?.address}
            </span>
          </div>
        </div>
        <div className='col-12'>
          <div className='form-group d-flex flex-row'>
            {paymentLoading ? (
              <button disabled className='btn btn-warning f-15'>
                <div
                  class='spinner-border spinner-border-sm text-white'
                  role='status'
                ></div>
              </button>
            ) : (
              <button
                onClick={() => handlePay()}
                className='btn btn-warning f-15'
              >
                پرداخت
              </button>
            )}

            {walletLoading ? (
              <button className='btn btn-primary f-15 mx-3'>
                <div
                  class='spinner-border spinner-border-sm text-white'
                  role='status'
                ></div>
              </button>
            ) : (
              <button
                onClick={() => handlePay(true)}
                className='btn btn-primary f-15 mx-3'
              >
                پرداخت با کیف پول
              </button>
            )}
          </div>
        </div>
      </div>
    </Master>
  );
};

export default ShowFactor;
